import moment from 'moment'

export const hasDisabledSubmit = (
  shiftDate: moment.Moment,
  shiftClockOut: string,
  formClockIn: string,
  formClockOut: string
): boolean => {
  if (!formClockIn) return true

  if (shiftClockOut && !formClockOut) return true

  const now = moment()

  const [clockInHours, clockInMinutes] = formClockIn.split(':')
  const clockIn = shiftDate
    .clone()
    .utcOffset(now.utcOffset())
    .hours(Number(clockInHours))
    .minutes(Number(clockInMinutes))
  const clockInIsFuture = !!formClockIn && clockIn.isAfter(now)

  if (!formClockOut) return clockInIsFuture

  const [clockOutHours, clockOutMinutes] = formClockOut.split(':')
  const clockOut = shiftDate
    .clone()
    .utcOffset(now.utcOffset())
    .hours(Number(clockOutHours))
    .minutes(Number(clockOutMinutes))

  if (clockIn.isAfter(clockOut)) clockOut.add(1, 'days')
  const clockOutIsFuture = clockOut.isAfter(now)

  return clockInIsFuture || clockOutIsFuture
}
